import React, { useEffect } from "react";
import Ico from "/assets/img/icons/checkbox.svg";
import { NavLink } from "react-router-dom";
import { useTranslation } from "/utils/hooks/useCustomTranslation";

export default function Checkbox({
  checked,
  title,
  handleChange,
  value,
  children = undefined,
  def,
  underline,
  dot,
  ...props
}) {
  const { t } = useTranslation();

  const agree = () => (
    <span className="txt">
      {t("registration.labels.agree.label")}{" "}
      <a
        href="/terms-and-conditions.pdf"
        title={t("layout.menus.terms")}
        target="_blank"
      >
        {t("layout.menus.terms")}
      </a>{" "}
      {t("registration.labels.agree.labelAnd")}{" "}
      <a
        href="/privacy-policy"
        title={t("layout.menus.privacy")}
        target="_blank"
      >
        {t("layout.menus.privacy")}
      </a>
    </span>
  );

  useEffect(() => {
    if (def) {
      const el = { target: { checked: true, ...props } };
      handleChange(el);
    }
  }, []);

  return (
    <>
      {underline && <div className="underline"></div>}
      <label
        className={`label checkbox ${value ? "active" : ""}`}
        title={title}
      >
        <div className="row">
          <input checked={value} onClick={handleChange} readOnly {...props} />
          <div
            className={`${
              dot ? `check-dot${value ? " active" : ""}` : "ico df br-8"
            }`}
          >
            {!dot && <Ico />}
          </div>
          {children ??
            (props.name == "agree" ? (
              agree()
            ) : (
              <span
                className="txt"
                dangerouslySetInnerHTML={{ __html: title }}
              ></span>
            ))}
        </div>
      </label>
    </>
  );
}
